// src/design-system/theme/colors.ts
export const colors = {
  // Base Colors
  white: "#FFFFFF",
  black: "#000000",
  transparent: "transparent",

  // Primary Brand Tokens
  primaryExtraLight: "#DCE9F7", //100
  primaryLight: "#9BBDD8", //200
  primarySoft: "#5B8ED0", //300
  primaryHover: "#2B63B0", //400
  primary: "#003D8A", //500 --> MAIN
  primaryActive: "#003982", //600
  primaryDark: "#003478", //700
  primaryDarker: "#002861", //800
  primaryDarkest: "#001A3A", //900

  // custom
  primarySlate: "#324259",
  primarySlateCard: "#3A4D68",
  primarySlateSoft: "#425B76",
  primarySlateLight: "#DFE3EB",
  primarySlateLighter: "#F5F8FA",

  // Teal/Mint Colors
  tealBgSubtle: "#E2F7EF", //100
  teal: "#3EBD89", //500
  tealStrong: "#35A377", //600

  // Dark Text Neutrals
  textWeak: "#747C90", // 100
  textMuted: "#656E85", // 200
  textLightMuted: "#5C657D", // 300
  textSubtle: "#525C76", // 400
  textDefault: "#49536E", // 500
  textStrong: "#3A4662", // 600
  textDarker: "#2C3857", // 700
  textDarkest: "#192648", // 800
  textInverse: "#0F1D40", // 900

  // Light UI Neutrals (Backgrounds / Borders)
  surfaceLightest: "#FAFAFB", // 100
  surfaceLighter: "#F5F6F7", // 200
  surfaceLight: "#EEF1F2", // 300
  surfaceSubtle: "#E2E4E8", // 400
  surface: "#CACDD5", // 500
  surfaceDark: "#B2B7C2", // 600
  surfaceDarker: "#A4A9B6", // 700
  surfaceDarkest: "#959CAB", // 800
  borderMuted: "#8C93A3", // 900
  surfaceSofter: "#F1F6FC", // 1000
  modalBodyBg: "#F5F6F7", // Modal body background
  modalFooterBg: "#EEEFF2",

  // Warning Colors
  warningBgSubtle: "#FFF4D6", //100
  warningBgHover: "#FFE8A8", //200
  warningBorder: "#FFD97A", //300
  warningHover: "#FFC84A", //400
  warning: "#FAAD14", //500
  warningStrong: "#B8740A", //600
  warningDark: "#8C5300", //700
  warningDarker: "#6B3F00", //800
  warningDarkest: "#4A2D00", //900

  // Error Colors
  errorBgSubtle: "#FFE7E8", //100
  errorBgHover: "#FFCDCE", //200
  errorBorder: "#FFA3A4", //300
  errorHover: "#FF787A", //400
  error: "#FF4D4F", //500
  errorStrong: "#D22427", //600
  errorDark: "#A61719", //700
  errorDarker: "#7E1012", //800
  errorDarkest: "#7A0933", //900

  // Success Colors
  successBgSubtle: "#E5FAD6", //100
  successBgHover: "#C2F0A8", //200
  successBorder: "#9AE37B", //300
  successHover: "#76D44F", //400
  success: "#52C41A", //500
  successStrong: "#3B9A15", //600
  successDark: "#2C7A11", //700
  successDarker: "#1F5C0D", //800
  successDarkest: "#14420A", //900

  // Info Colors
  infoBgSubtle: "#D7ECFF", //100
  infoBgHover: "#A5D7FF", //200
  infoBorder: "#7BC1FF", //300
  infoHover: "#4CA8FF", //400
  info: "#1890FF", //500
  infoStrong: "#0F7FEF", //600
  infoDark: "#006AD9", //700
  infoDarker: "#0053A7", //800
  infoDarkest: "#071971", //900

  // Chip Colors
  chipBg: "#DCE9F7",
  chipBgHover: "#C9DEF3",
  chipText: "#006AD9",

  // Tab Color Themes (8 different light color schemes)
  // Tab 1 - Blue (Primary)
  tab1Bg: "#E8F4FD",
  tab1Border: "#5B8ED0",
  tab1Text: "#003D8A",
  tab1ActiveBorder: "#003D8A",

  // Tab 2 - Teal/Cyan
  tab2Bg: "#E6F7F5",
  tab2Border: "#5BBFB3",
  tab2Text: "#147A6E",
  tab2ActiveBorder: "#147A6E",

  // Tab 3 - Purple
  tab3Bg: "#F3E8FD",
  tab3Border: "#A07CD0",
  tab3Text: "#5E3D8A",
  tab3ActiveBorder: "#5E3D8A",

  // Tab 4 - Orange
  tab4Bg: "#FEF3E8",
  tab4Border: "#D09B5B",
  tab4Text: "#8A5A14",
  tab4ActiveBorder: "#8A5A14",

  // Tab 5 - Green
  tab5Bg: "#E8FDE8",
  tab5Border: "#6BBF6B",
  tab5Text: "#2D7A2D",
  tab5ActiveBorder: "#2D7A2D",

  // Tab 6 - Rose/Pink
  tab6Bg: "#FDE8F0",
  tab6Border: "#D07AA0",
  tab6Text: "#8A3D5E",
  tab6ActiveBorder: "#8A3D5E",

  // Tab 7 - Indigo
  tab7Bg: "#EAEAFD",
  tab7Border: "#7A7AD0",
  tab7Text: "#3D3D8A",
  tab7ActiveBorder: "#3D3D8A",

  // Tab 8 - Amber
  tab8Bg: "#FDF8E8",
  tab8Border: "#D0B85B",
  tab8Text: "#7A6414",
  tab8ActiveBorder: "#7A6414",
};
